var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("page-content-creator", {
                attrs: { itemid: _vm.itemid, pos: "top" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("page-content-creator", {
                attrs: { itemid: _vm.itemid, pos: "top" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _vm.itemid
                ? _c("node-element-local-tasks", {
                    attrs: { itemid: _vm.itemid },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.notpublished
                ? _c("div", { staticClass: "messages warning" }, [
                    _vm._v("Not published"),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "faq" },
              [
                _c("h4", { staticClass: "faq-category" }, [
                  _vm._v("\n          " + _vm._s(_vm.category) + "\n        "),
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "faq-title" }, [
                  _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
                ]),
                _vm._v(" "),
                _c("page-content-wysiwg-content", {
                  staticClass: "faq-body",
                  attrs: { item: _vm.item },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("page-content-creator", {
                attrs: { itemid: _vm.itemid, pos: "bottom" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }